import List from "@/components/list";

const AutoTable = args => {
  const AccountTableConfigAuto = [
    {
      label: "试题名称",
      prop: "questionTitle",
      showOverflowTooltip: true
    },
    {
      label: "试题类型",
      prop: "examQuestionTypeName"
    },
    {
      label: "试题主题",
      prop: "questionTheme"
    }
  ];

  return (
    <List
      {...args}
      empty-text="尚未添加任何试题，点击右上角【试题管理】可进行试题添加"
      talbeCols={AccountTableConfigAuto}
    />
  );
};

export default AutoTable;
